import Icon from "@material-ui/icons/Person";
import CcaScheduleCreate from "./CcaScheduleCreate";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "ccaStudentSchedules",
  create: CcaScheduleCreate,
  icon: Icon,
};
